import { API, graphqlOperation } from 'aws-amplify'
import { listAudits as listAuditsQuery } from '@/graphql/queries'
import { createAudit, createQuestionModel, createChecklistModel, updateAudit } from '@/graphql/mutations'

// helper methods
async function editAudit(audit) {
    try {
        ( { data: { updateAudit: audit } } = await API.graphql(graphqlOperation(updateAudit, {input:audit})) )
        return audit
    } catch(err) {
        console.log("Error updating audit", err)
    }
}
async function saveAudit(audit) {
    try {
        let listPromises = audit.lists.map(l => saveList(audit, audit, l, true))
        await Promise.all(listPromises)
        audit.lists = undefined
        console.log("saving audit", audit)

        return API.graphql(graphqlOperation(createAudit, {input: audit}))
    }
    catch (err) {
        console.log('error adding item: ', err)
    }
}

async function saveList(audit, parent, list, toplevel) {

    if(!toplevel) {
        list['list'] = parent.id
    }
    list['audit'] = audit.id

    let questionPromises = list.questions.map(q => saveQuestion(audit, list, q))
    let sublistPromises = list.sublists.map(l => saveList(audit, list, l))
    await Promise.all(questionPromises)
    await Promise.all(sublistPromises)

    list.questions = undefined
    list.sublists = undefined

    return API.graphql(graphqlOperation(createChecklistModel, {input: list}))
}

async function saveQuestion(audit, parent, question) {
    question['list'] = parent.id
    question['audit'] = audit.id
    console.log("Saving question ", question)
    return API.graphql(graphqlOperation(createQuestionModel, {input: question}))

}

async function listAudits(filter) {
    let audits = []
    var nextToken, items
    do {
        ( { data: { listAudits: { items, nextToken } } } = await API.graphql(graphqlOperation(listAuditsQuery, {filter, nextToken})) )
        audits.push(...items)
    } while( nextToken )
    return audits
}

// Vuex stat
const state = {
    all: []
}

// Vuex getters
const getters = {
    audits: (state) => {
        return state.audits
    },
    auditById: (state) => (id) => state.all.find(a => a.id == id)
}

// Vuex actions
const actions = {
    async loadAudits({ commit }, username) {
        try {
            let filter =  {
                owner: {
                    eq:username
                },
                deleted: {
                    ne:true
                }
            }

            commit('setAudits', [])
            let audits = await listAudits(filter)
            commit('setAudits', audits)
        }
        catch (err) {
            console.log('error listing audits: ', err)
        }
    },
    async loadReviews({commit }, username) {
        commit('setAudits', [])
        console.log("loadReviews", username)
        try {
            let filter =  {
                state: {
                    eq:"in-review"
                }
            }
            let audits = await listAudits(filter)
            commit('setAudits', audits)
        } catch(err) {
            console.log("error searching audits", err)
        }
    },
    async loadCompleted({commit}, username) {
        commit('setAudits', [])
        console.log("loadShared", username)
        try {
            let filter =  {
                state: {
                    eq:"complete"
                }
            }
            let audits = await listAudits(filter)
            commit('setAudits', audits)
        } catch(err) {
            console.log("error searching audits", err)
        }
    },
    async newAudit({ commit }, audit) {
        await saveAudit(audit)
        commit('addAudit', audit)
    },
    async searchAudits({ commit }, searchParams) {
        try {
            let audits = await listAudits(searchParams)
            commit('setAudits', audits)
        }
        catch (err) {
            console.log("error searching audits: ", err)
        }
    },
    async archiveAudit({ commit }, {auditId, archived} ) {
        let newAudit = await editAudit ( {id:auditId, archived})
        commit('setAudit', newAudit)
    },
    async deleteAudit({ commit }, {auditId}) {
        let newAudit = await editAudit( {id:auditId, deleted:true})
        commit('setAudit', newAudit)
    }
}

// Vuex mutations
const mutations = {
    setAudits(state, audits) {
        state.all = audits
    },
    setAudit(state, audit) {
        let idx = state.all.findIndex(el => el.id == audit.id)
        if(idx != -1) {
            state.all[idx] = audit;
        }
        state.all = state.all.slice(0).filter(a => !a.deleted)
    },
    addAudit(state, audit) {
        state.all.push(audit)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
